import React, { FunctionComponent, useMemo } from 'react';

import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';

import useTranslation from '../../translations/useTranslation';
import Input from '../Input';

export type KeywordProps = {
  inputLabel?: string;
  keyword?: string;
  onChange?: (keyword?: string) => void;
};

const useStyles = () => {
  const { breakpoint, fonts, spacing, colors } = useTheme();

  return useMemo(() => {
    return {
      input: {
        flexGrow: 1,
        margin: spacing(0, 4, 2, 0),
        '& input': {
          ...fonts.headline3,
          [breakpoint.up('md')]: {
            ...fonts.headline1,
          },
        },
      },
      adornment: {
        '& svg': {
          color: colors.anakiwa,
        },
        '& button:hover, & button:focus': {
          '& svg': {
            color: colors.white,
          },
        },
      },
    };
  }, [spacing, colors, fonts, breakpoint]);
};

const Keyword: FunctionComponent<KeywordProps> = (props) => {
  const { inputLabel, keyword, onChange } = props;
  const t = useTranslation();

  const classes = useStyles();

  return (
    <Flex flexDirection="column" alignItems="stretch">
      <Text gutter={4} variant="headline1">
        {inputLabel ? inputLabel : t('searching_for_a_job')}
      </Text>
      <Input
        disabled
        data-testid="KeywordInput"
        css={classes.input}
        value={keyword}
        onChange={(e) => onChange?.(e.currentTarget?.value)}
        placeholder={t('keywordPlaceholder')}
      />
    </Flex>
  );
};

export default Keyword;
